import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M826-436q0 32-5.5 65.5T802-306l-85-85q2-11 2.5-21.5t.5-23.5q0-48-17-88t-51-74L480-768l-70 69-75-75 145-144 246 244q48 48 74 106t26 132ZM798-14 665-147q-43 26-88.5 39.5T480-94q-143 0-244.5-99.5T134-436q0-47 14-95.5t43-89.5L14-798l74-74L872-88l-74 74ZM480-200q27 0 51.5-5.5T587-225L267-543q-15 29-21 55t-6 52q0 98 70 167t170 69Zm-53-184Zm131-138Z" }, null, -1)
  ]))]))
}
export default { render: render }